import { useStatsigClient } from '@statsig/react-bindings'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { legacyTemperatureUploadPath } from './fileUploadQueueNavigation'

/**
 * Route element for the File Upload Queue paths while the `file-upload-queue-v1` gate is off: sends
 * the user to today's upload page without loading any queue code.
 */
export default function FileUploadQueueLegacyRedirect() {
  const { view, shipmentUuid } = useParams()
  const location = useLocation()
  const { client } = useStatsigClient()
  return (
    <Navigate
      replace
      to={legacyTemperatureUploadPath(view, shipmentUuid, client)}
      state={location.state}
    />
  )
}
